module.exports = __webpack_public_path__ + "img/keyboard_key_0.baf239c7.png";